(() => {
  window.swinger.eventHub.register('click', '.swinger-verification_verification', () => {
  });
  window.swinger.eventHub.register('click', '.swinger-verification_decline', () => {
  });
})();
